import React from 'react';
import { IPaymentMethod } from '@components/Sura/PaymentMethodCard/types';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import useStyles from '@components/Sura/PaymentMethodCard/styles';
import Typography from '@material-ui/core/Typography';
import useStore from '@hooks/useStore';
import { observer } from 'mobx-react';
import { PaymentMethod, PaymentOption } from '@store/sura';
import { CircularProgress } from '@material-ui/core';

const PaymentMethodCard: React.FC<IPaymentMethod> = ({
  imageSrc,
  paymentMethod,
  description,
  disabled = false,
  paymentMethodSelected = '',
  paymentOption = '',
}) => {
  const { sura, ui, links } = useStore();
  const css = useStyles({ disabled, isMobile: ui.isMobileScreen });
  const externalRefId = links.paymentLink.externalRefId;

  const handlePaymentMethod = () => {
    const url = window.location.href;
    if (sura.step === 0) {
      sura.setPaymentMethod(paymentMethodSelected);
      if (paymentMethodSelected === PaymentMethod.card) {
        history.pushState(null, '', `${url}/online-payment`);
        sura.setStep(1);
      } else if (paymentMethodSelected === PaymentMethod.cash) {
        history.pushState(null, '', `${url}/shared`);
        sura.setSendReceipt(true);
        sura.setStep(4);
      } else if (paymentMethodSelected === PaymentMethod.bankReference) {
        history.pushState(null, '', `${url}/bank-reference`);
        sura.setStep(1);
      } else if (paymentMethodSelected === 'send-reference') {
        history.pushState(null, '', `${url}/send-reference`);
        sura.setStep(4);
        sura.setSendReceipt(true);
      }
    } else if (sura.step === 1) {
      sura.setPaymentOption(paymentOption);
      if (paymentOption !== PaymentOption.download_reference) sura.setStep(2);
      if (
        paymentOption === PaymentOption.visa_mastercard ||
        paymentOption === PaymentOption.american
      ) {
        const cardType =
          paymentOption === PaymentOption.visa_mastercard ? '/visa-mastercard' : '/amex';
        history.pushState(null, '', `${url}/card${cardType}`);
      } else if (paymentOption === PaymentOption.clabe) {
        history.pushState(null, '', `${url}/direct-debit`);
      } else if (paymentOption === PaymentOption.send_reference) {
        history.pushState(null, '', `${url}/send-reference`);
        sura.setStep(4);
        sura.setSendReceipt(true);
      } else if (paymentOption === PaymentOption.download_reference) {
        sura.postBankReference(externalRefId, 'download', '');
      }
    }
  };

  return (
    <Card classes={{ root: css.card }}>
      <CardActionArea disabled={disabled} onClick={handlePaymentMethod} className={css.actionArea}>
        <div className={css.divCard}>
          <img src={imageSrc} alt="PaymentMethodIMG" />
          <div>
            <Typography className={css.labelPayment}>{paymentMethod}</Typography>
            {paymentOption === PaymentOption.download_reference ? (
              disabled ? (
                <div className={css.divLoading}>
                  <CircularProgress className={css.loading} />
                </div>
              ) : (
                <Typography className={css.description}>{description}</Typography>
              )
            ) : (
              <Typography className={css.description}>{description}</Typography>
            )}
          </div>
        </div>
      </CardActionArea>
    </Card>
  );
};

export default observer(PaymentMethodCard);
